// 全角のアルファベット、数字、記号、空白 を半角に変換
export const zenToHan = (str: string): string => {
  return str.replace(
    /[０-９ａ-ｚＡ-Ｚ！＂＃＄％＆＇（）＊＋，－．／：；＜＝＞？＠Ｚ¥［］＾＿｀｜｝]/g,
    function (s) {
      return String.fromCharCode(s.charCodeAt(0) - 0xfee0)
    }
  )
}
